import { render } from "./LevelSkills.vue?vue&type=template&id=2a514cb6&ts=true"
import script from "./LevelSkills.vue?vue&type=script&lang=ts"
export * from "./LevelSkills.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__